
const digest = 'f294a4ad50ae54621690b6b965ca4dedaab3ddaf1241144b8ef25d31c453d6e8';
const classes = {"pillButton":"_pillButton_sn2y1_1","pill":"_pill_sn2y1_1"};
const css = `._pillButton_sn2y1_1 {
  position: relative;
}
._pillButton_sn2y1_1 ._pill_sn2y1_1 {
  height: 22px;
  width: 60px;
  position: absolute;
  z-index: 1;
  margin-left: 25px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  